import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,_vm._b({attrs:{"top":_vm.hasDirection ? false : true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({staticClass:"vizNowTooltip"},'span',Object.assign({}, attrs, _vm.$attrs, _vm.$props),false),on),[_vm._t("default")],2)]}}],null,true)},'v-tooltip',_vm.$props,false),[_c('span',[_vm._t("text",function(){return [_vm._v(" "+_vm._s(_vm.text)+" ")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }